// extracted by mini-css-extract-plugin
export default {"checkbox_round":"Cart_checkbox_round__El97V","blueColore":"Cart_blueColore__FRsIU"};